module.exports = __webpack_public_path__ + "img/button_search_dark.c4e133e9.png";